;(function($) {
  "use strict"
  $(function() {
    $(window).scroll(function () {
      // Если отступ сверху больше 100px то показываем кнопку "Наверх"
      if ($(this).scrollTop() > 100) {
        $('.go-top').fadeIn();
      } else {
        $('.go-top').fadeOut();
      }
    });

    /** При клике по кнопке перемещаемся к началу страницы */
    $('.go-top').click(function () {
      $('body,html').animate({
        scrollTop: 0
      }, 300);
      return false;
    });
  })
})(jQuery)
